import Swal from 'sweetalert2';

export default {
  name: 'MedicaidRepeatable',
  props: ['medicaidArray', 'student', 'index', 'record', 'showTooltip', 'v'],
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    minutesErrors() {
      const errors = [];
      const minutes = this.v.$each[this.index].minutes;
      if (!minutes.$dirty) return errors;
      if (!minutes.required) errors.push('Minutes are required.');
      if (!minutes.areMinutesGreaterThanZero) errors.push('Minutes must be greater than 0.');
      if (!minutes.isValidMinutes) errors.push('Invalid minutes.');
      return errors;
    },
    procedureErrors() {
      const errors = [];
      const procedure = this.v.$each[this.index].procedures;
      if (!procedure.$dirty) return errors;
      if (!procedure.required) errors.push('Procedure Description is required.');
      return errors;
    },
    outcomeErrors() {
      const errors = [];
      const outcome = this.v.$each[this.index].outcome;
      if (!outcome.$dirty) return errors;
      if (!outcome.required) errors.push('Outcome is required.');
      return errors;
    }
  },
  methods: {
    emitRemoveRecordClicked() {
      Swal.fire(
        {
          type: 'warning',
          text: 'Are you sure you want to delete this record?',
          showCancelButton: true
        })
        .then((response) => {
          if (response && response.value) this.$emit('delete:record', { index: this.index });
        });
    },
    emitAddRecordClicked() {
      this.$emit('add:record');
    },
    createProcedureObject(otherName) {
      return {
        categoryId: null,
        categoryName: 'Other',
        categorySortOrder: null,
        disabled: false,
        procedureFullName: `Other: ${otherName}`,
        procedureId: null,
        procedureName: otherName,
        procedureSortOrder: null,
        reimbursable: false
      };
    },
    formatProcedureArrayForSubmit(index) {
      // mark the field as touched for validations
      this.v.$each[index].procedures.$touch()
      // set the procedure array, create an object if procedure is other
      this.record.procedures = this.record.procedures.map((procedure) => {
        if (typeof procedure === 'string') {
          return this.createProcedureObject(procedure);
        }
        return {
          ...procedure
        };
      });
    },
    remove(item) {
      this.record.procedures = this.record.procedures.filter((proc) => {
        return proc.procedureName !== item;
      });
    }
  },
  watch: {
    // calculate total minutes is minutes changes
    'record.minutes': function () {
      this.$emit('calculate:minutes');
    },
    // calculate total minutes if procedures change
    'record.procedures': function () {
      this.$emit('calculate:minutes');
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/service-log/form/medicaid-repeatable/medicaid-repeatable.js